import script from "./forget-password.vue?vue&type=script&setup=true&name=forget-password&lang=js"
export * from "./forget-password.vue?vue&type=script&setup=true&name=forget-password&lang=js"

import "./forget-password.vue?vue&type=style&index=0&id=7e6c0f09&lang=scss&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6c0f09"]])

export default __exports__